import {Injectable} from '@angular/core';
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  logout() {
    sessionStorage.clear();
    window.location.href = `${environment.nam.urlEndSession}`;
    //?post_logout_redirect_uri=${encodeURIComponent(environment.logoutPath)}&id_token_hint=${sessionStorage.getItem('id_token')}
  }
}
